import { render, staticRenderFns } from "./PrintStudentList.vue?vue&type=template&id=516bcfcb&"
import script from "./PrintStudentList.vue?vue&type=script&lang=js&"
export * from "./PrintStudentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports